export default __webpack_public_path__ + "static/media/NOVA-AI-Mascot.acc1415d.png";